import { type GameItemsType } from '@common/types/common';
import { type PlantTypeText } from '@common/types/plant';
import { type ResourceTypeText } from '@common/types/resource';

// import { type ResourceTypeText } from '@common/types/resource';
import { type BoostCardProps } from '../types/components';
import { type BoostType } from '../types/factoryType';

const resourceList: ResourceTypeText[] = [
  'wood',
  'cotton',
  'bulk',
  'iron',
  'oil',
  'precious',
];

const materialsList: PlantTypeText[] = [
  'lumber',
  'textiles',
  'bricks',
  'paper',
  'steel',
  'plastic',
  'glass',
  'fuels_and_oils',
  'microchips',
];

const goodsList: string[] = [
  'furniture',
  'upholstered_furniture',
  'garden_furniture',
  'office_furniture',
  'clothing',
  'footwear',
  'accessories',
  'sports_equipment',
  'books',
  'packaging',
  'photo_frames',
  'stationery',
  'home_textiles',
  'lamps',
  'tableware',
  'electric_fireplaces',
  'hand_tools',
  'garden_tools',
  'electronic_tools',
  'machines',
  'soft_toys',
  'board_games',
  'construction_toys',
  'electronic_toys',
  'guitar',
  'electric_guitar',
  'light_music',
  'speakers',
  'washing_machine',
  'laptop',
  'vr_equipment',
  'robotics',
  'car',
  'train',
  'airplane',
  'ship',
];

const childrensGoodsList = [
  'board_games',
  'construction_toys',
  'electronic_toys',
  'soft_toys',
];
const electronicsList = [
  'laptop',
  'robotics',
  'vr_equipment',
  'washing_machine',
];
const furnitureFactoryList = [
  'furniture',
  'garden_furniture',
  'office_furniture',
  'upholstered_furniture',
];
const garmentFactoryList = [
  'accessories',
  'clothing',
  'footwear',
  'sports_equipment',
];
const homewareList = [
  'electric_fireplaces',
  'home_textiles',
  'lamps',
  'tableware',
];
const machineryList = ['airplane', 'car', 'ship', 'train'];
const musicalEquipmentList = [
  'electric_guitar',
  'guitar',
  'light_music',
  'speakers',
];
const printingFactoryList = [
  'books',
  'packaging',
  'photo_frames',
  'stationery',
];
const toolmakingList = [
  'electronic_tools',
  'garden_tools',
  'hand_tools',
  'machines',
];

const goodsListByWorkshop: Record<string, string[]> = {
  childrens_goods: childrensGoodsList,
  electronics: electronicsList,
  furniture_factory: furnitureFactoryList,
  garment_factory: garmentFactoryList,
  homeware: homewareList,
  machinery: machineryList,
  musical_equipment: musicalEquipmentList,
  printing_factory: printingFactoryList,
  toolmaking: toolmakingList,
};

const gameItemOrder: Record<GameItemsType, string[]> = {
  resource: resourceList as string[],
  material: materialsList as string[],
  goods: goodsList,
};

const boostList: [
  BoostType,
  Omit<BoostCardProps, 'resource' | 'plantType' | 'plantId'>,
][] = [
  ['Free', { id: '-', boostType: 'Free', plants: [], effectMultiplier: 2 }],
  [
    'Advertising',
    {
      id: '-',
      boostType: 'Advertising',
      plants: [],
      effectMultiplier: 2,
      quantity: { limit: 0, available: 0 },
    },
  ],
  ['VIP', { id: '-', boostType: 'VIP', plants: [], effectMultiplier: 2 }],
  ['Paid', { id: '-', boostType: 'Paid', plants: [], effectMultiplier: 2 }],
];

const shortBoostList: [
  BoostType,
  Omit<BoostCardProps, 'resource' | 'plantType' | 'plantId'>,
][] = [
  ['Free', { id: '-', boostType: 'Free', plants: [], effectMultiplier: 2 }],
  ['VIP', { id: '-', boostType: 'VIP', plants: [], effectMultiplier: 2 }],
];

export {
  boostList,
  gameItemOrder,
  goodsList,
  goodsListByWorkshop,
  materialsList,
  resourceList,
  shortBoostList,
};
